module.exports = __webpack_public_path__ + "static/scrollTop-b434981b18d76ee6942ec868cf261c2f.svg";